<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">

    <div class="filter my-3">
      <div class="filter-head">
        <h4>رسائل الحجز — {{ year?.name ?? '...' }}</h4>
        <div class="buttons">
          <router-link :to="`/academic-years/${yearId}/edit`" class="btn btn-outline-primary">
            <i class="pi pi-arrow-right me-1"></i> رجوع لتعديل السنة الدراسية
          </router-link>
        </div>
      </div>
      <p class="text-muted mb-0">
        اترك أي حقل فارغاً لاستخدام رسالة المجموعة إن وجدت، أو النص الافتراضي من "نصوص الموقع".
      </p>
    </div>

    <div v-if="loading" class="text-center py-5">
      <i class="pi pi-spin pi-spinner" style="font-size:1.5rem;"></i>
    </div>

    <form v-else @submit.prevent="save">
      <div class="row g-4">
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">رسالة قبول الطالب</label>
            <Editor v-model="messages.accept_message" editorStyle="height: 180px" />
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">رسالة رفض الطالب</label>
            <Editor v-model="messages.reject_message" editorStyle="height: 180px" />
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">رسالة الطالب معلق</label>
            <Editor v-model="messages.waiting_message" editorStyle="height: 180px" />
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">الرسالة بعد إرسال الطلب</label>
            <Editor v-model="messages.after_submit_message" editorStyle="height: 180px" />
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">عنوان رسالة انتظار الشهادة</label>
            <Editor v-model="messages.waiting_certificate_title" editorStyle="height: 180px" />
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">نص رسالة انتظار الشهادة</label>
            <Editor v-model="messages.waiting_certificate_message" editorStyle="height: 180px" />
          </div>
        </div>
      </div>

      <div class="mt-3 text-end">
        <button type="submit" class="btn PrimaryButton" :disabled="saving">
          <i class="pi pi-spin pi-spinner-dotted" v-if="saving"></i>
          {{ saving ? 'جاري الحفظ...' : 'حفظ الرسائل' }}
        </button>
      </div>
    </form>

  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Editor from 'primevue/editor';
import Breadcrumb from '@/components/global/breadcrumb.vue';

const MESSAGE_FIELDS = [
  'accept_message',
  'reject_message',
  'waiting_message',
  'after_submit_message',
  'waiting_certificate_title',
  'waiting_certificate_message',
];

export default {
  name: 'AcademicYearMessages',
  components: { Editor, Breadcrumb },

  data() {
    return {
      year: null,
      loading: true,
      saving: false,
      messages: Object.fromEntries(MESSAGE_FIELDS.map(f => [f, ''])),
    };
  },

  computed: {
    yearId() { return this.$route.params.id; },
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: 'السنوات الدراسية', path: '/academic-years' },
        { name: this.year?.name ?? 'السنة الدراسية', path: `/academic-years/${this.yearId}/edit` },
        { name: 'رسائل الحجز', path: `/academic-years/${this.yearId}/messages` },
      ];
    },
  },

  methods: {
    async fetchYear() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/academic-years/${this.yearId}`);
        this.year = data.data;
        this.messages = Object.fromEntries(MESSAGE_FIELDS.map(f => [f, this.year?.[f] ?? '']));
      } finally {
        this.loading = false;
      }
    },

    async save() {
      this.saving = true;
      try {
        const { data } = await axios.put(`/academic-years/${this.yearId}`, {
          ...this.messages,
        });
        this.year = data.data;
        Swal.fire('', 'تم حفظ رسائل الحجز بنجاح', 'success');
      } catch (error) {
        Swal.fire('', error.response?.data?.message || 'حدث خطأ أثناء الحفظ', 'error');
      } finally {
        this.saving = false;
      }
    },
  },

  mounted() {
    this.fetchYear();
  },
};
</script>

<style scoped>
</style>
